import { injectable } from 'inversify';
import 'reflect-metadata';

import { IAuthService } from '@@/auth/services/IAuthService.interface';
import {
  AUTH_SSO_CLIENT_ID_QUERY,
  AUTH_SSO_REDIRECT_URL_QUERY,
  AUTH_SSO_SCOPE_QUERY,
  AUTH_SSO_USER_TYPE,
} from '@@/auth/constants/sso-query.constants';
import { get, post } from '@api/api-client';

@injectable()
export class AuthService implements IAuthService {
  checkAuth() {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = -offsetMinutes / 60;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return post<Awaited<ReturnType<IAuthService['checkAuth']>>>(
      `${PUBLIC_API_URL}/auth`,
      { 
        user_hours_offset: offsetHours,
        user_timezone: timeZone
       },
      document.cookie,
    );
  }

  loginInSso(options?: { redirectUrl: string }) {
    this.redirectToSSO({ redirectUrl: options?.redirectUrl, ssoUrl: 'login' });
  }
  signUpInSso(options?: { redirectUrl?: string; user_type?: 'seller' | 'buyer' }) {
    this.redirectToSSO({
      redirectUrl: options?.redirectUrl,
      ssoUrl: 'register',
      user_type: options?.user_type,
    });
  }

  logout() {
    return get<Awaited<ReturnType<IAuthService['logout']>>>(
      `${PUBLIC_API_URL}/auth/logout`,
    );
  }

  private redirectToSSO(options: {
    redirectUrl?: string;
    ssoUrl: string;
    user_type?: string;
  }) {

    const params = new URLSearchParams({
      [AUTH_SSO_CLIENT_ID_QUERY]: PUBLIC_SSO_CLIENT_ID,
      [AUTH_SSO_REDIRECT_URL_QUERY]: options?.redirectUrl || window.location.href,
      [AUTH_SSO_SCOPE_QUERY]: options.user_type === 'buyer' ? 'buyer' : PUBLIC_SSO_SCOPE,
      //...(options.user_type ? { [AUTH_SSO_USER_TYPE]: String(options?.user_type) } : {}),
    });

    window.location.href = `${PUBLIC_SSO_URL}/${options.ssoUrl}?${params.toString()}`;
  }
}
